export enum ActivatePackageErrorEnum {
  PAYOUT_INIT_REQUIRED = 'PAYOUT_INIT_REQUIRED',
  EVENT_PACKAGE_REQUIRED = 'EVENT_PACKAGE_REQUIRED',
  TICKET_PACKAGE_REQUIRED = 'TICKET_PACKAGE_REQUIRED',
  COURSE_PACKAGE_REQUIRED = 'COURSE_PACKAGE_REQUIRED',
  SUBSCRIPTION_REQUIRED = 'SUBSCRIPTION_REQUIRED',
}
